import { formatBytes } from '@frameio/utils/formatters';
import TEXT from './generated/TEXT/JobSize';

TEXT.DEFINE({
  /** Progress text showing uploaded size out of total (e.g., "1.2 MB of 5.0 MB") */
  uploadProgress: (bytesSent: string, bytesTotal: string): string =>
    `${bytesSent} of ${bytesTotal}`,
});

type JobSizeProps = {
  bytesTotal?: number | null;
  bytesSent?: number;
};

export const JobSize = ({ bytesTotal = 0, bytesSent = 0 }: JobSizeProps) => {
  const formattedTotal = formatBytes(bytesTotal);
  const isInProgress = !!bytesSent && bytesSent !== bytesTotal;

  return (
    <span
      className="bytes"
      style={{
        display: 'inline-block',
      }}
    >
      {isInProgress
        ? TEXT.uploadProgress(formatBytes(bytesSent), formattedTotal)
        : formattedTotal}
    </span>
  );
};
